import Markdown from '@/common/atoms/Markdown'
import useDateLocale from '@/common/hooks/useDateLocale'
import {
  Badge,
  Box,
  Collapse,
  Flex,
  ListItem,
  Text,
  UnorderedList,
} from '@chakra-ui/react'
import { PublishedReleaseFragment } from '@gql'
import { format } from 'date-fns'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ChevronDownIcon, ChevronRightIcon } from 'src/icons'
import { itemText } from '../release'

interface Props {
  release: PublishedReleaseFragment
  latest: boolean
}

export default function ReleaseSection({ release, latest }: Props) {
  const { t } = useTranslation()
  const dateLocale = useDateLocale()
  const [open, setOpen] = useState(latest)
  const Chevron = open ? ChevronDownIcon : ChevronRightIcon

  return (
    <Box borderWidth={1} borderRadius="md">
      <Flex
        as="button"
        w="100%"
        textAlign="left"
        align="center"
        gap={3}
        px={4}
        py={3}
        flexWrap="wrap"
        aria-expanded={open}
        onClick={() => setOpen(!open)}
      >
        <Chevron size={16} />
        <Text fontWeight="bold">
          {release.version}
          {release.title && ` — ${release.title}`}
        </Text>
        {latest && (
          <Badge colorScheme="purple">{t('WhatsNewPage.latest')}</Badge>
        )}
        {release.publishedAt && (
          <Text ml="auto" fontSize="sm" color="gray.500">
            {t('WhatsNewPage.publishedOn', {
              date: format(new Date(release.publishedAt), 'PP', {
                locale: dateLocale,
              }),
            })}
          </Text>
        )}
      </Flex>

      <Collapse in={open} animateOpacity unmountOnExit>
        <UnorderedList spacing={2} pl={10} pr={4} pb={4}>
          {release.items.map((item) => (
            <ListItem key={item.id}>
              <Markdown>{itemText(item)}</Markdown>
            </ListItem>
          ))}
        </UnorderedList>
      </Collapse>
    </Box>
  )
}
